export const CURRENCY = {
    USD: "USD",
}
export type CURRENCY = typeof CURRENCY[keyof typeof CURRENCY]


// WEBPACK FOOTER //
// ./src/utils/currency/constants.ts